import React from 'react';
import PropTypes from 'prop-types';

import DeviceDiagramContainer from '../../containers/DeviceDiagramContainer';

const DeviceNode = React.memo(({ id, data }) => {
  return (
    <>
      <DeviceDiagramContainer elementId={id} id={data.id} />
    </>
  );
});

DeviceNode.propTypes = {
  id: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
};

DeviceNode.defaultProps = {
  id: undefined,
  data: undefined,
};

export default DeviceNode;
